<template>
  <div class="page p-create-at">
    <header class="at-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/pt/exercise-center' }"
          >练习中心</el-breadcrumb-item
        >
        <el-breadcrumb-item>个性化练习</el-breadcrumb-item>
      </el-breadcrumb>
      <card-header class="mt-20">创建个性化练习</card-header>
    </header>
    <p class="c-subtile">
      个性化作业支持老师划出知识点范围，系统根据学生能力水平，实时推送适合的题目，避免学霸重复做已会的题，避免学弱生做过难的题，每个学生只做适合自己的题目
    </p>
    <div class="hr"></div>
    <div class="create-at-content">
      <div class="f-left" ref="container">
        <div class="selector-container">
          <div
            class="version-header"
            @click="showVersion = !showVersion"
            :class="showVersion ? 'is-blue' : ''"
          >
            <p
              v-if="
                categoryObj.subjectId !== '' &&
                categoryObj.gradeId !== '' &&
                categoryObj.textbookId !== ''
              "
            >
              <span class="result-text">{{ categoryObj.subjectName }}</span> -
              <span class="result-text"
                >{{ categoryObj.gradeName }}{{ categoryObj.termName }}</span
              >
              -
              <span class="result-text">{{ categoryObj.textbookName }}</span>
            </p>
            <p v-else>请选择教材版本</p>
          </div>
          <!-- 章节列表 -->
          <course-list
            v-if="showVersion"
            fromType="4"
            @hideSubjectGradeText="hideSubjectGradeText"
          ></course-list>
        </div>
        <!-- 知识点列表 -->
        <choose-knowledgePoints
          :data="chapterList"
          :fromType="4"
          @toggle="onToggle"
          v-if="
            categoryObj.subjectId !== '' &&
            categoryObj.gradeId !== '' &&
            categoryObj.textbookId !== ''
          "
        ></choose-knowledgePoints>
      </div>
      <div class="f-main">
        <header>
          <card-header>布置设置</card-header>
          <button @click="previewResource" class="look">查看题目资源</button>
        </header>
        <!-- 发布页面 -->
        <publish-at></publish-at>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CRM_USER } from '@/config/storage';
import { getCmsCourseTree, getQuestionPackageList } from '@/api/pt';
import CardHeader from '@/components/card-header.vue';
import PublishAt from './components/publish-at.vue';
import ChooseKnowledgePoints from './components/choose-knowledgePoints.vue';
import CourseList from './components/choose-category.vue';

export default {
  name: 'CreateAt',
  components: {
    CardHeader,
    ChooseKnowledgePoints,
    PublishAt,
    CourseList,
  },
  data() {
    const userInfo = JSON.parse(localStorage.getItem(CRM_USER)) || {};
    return {
      showVersion: false,
      userInfo,
      chapterList: [],
      subjectId: this.$route.query.subjectId,
      gradeId: '',
      termId: '',
      textbookId: '',
    };
  },
  computed: {
    ...mapGetters(['categoryObj']),
  },
  methods: {
    // 重新选择版本操作
    hideSubjectGradeText(isNeedQuery) {
      this.showVersion = false;
      if (isNeedQuery) {
        this.queryCourseTree();
      }
    },
    // 查询当前版本章节列表
    queryCourseTree() {
      this.chapterList = [];
      this.$store.commit('CHOOSE_KNOWLEDGE', []);
      this.subjectId = this.categoryObj.subjectId;
      this.gradeId = this.categoryObj.gradeId;
      this.textbookId = this.categoryObj.textbookId;
      this.termId = this.categoryObj.termId;
      const params = {
        subject_id: this.subjectId,
        grade_id: this.gradeId,
        textbook_id: this.textbookId,
        extend_info: 1,
        term_id: this.termId,
        hw_type: 4,
      };
      getCmsCourseTree(params).then((res) => {
        if (res.code === 200) {
          const chapterArr = res.data;
          chapterArr.forEach((item, index) => {
            if (index === 0) {
              this.getQuestionPackageList(item);
              const courseInfo = {
                courseId: item.course_id,
                courseName: item.course_name,
                lessonId: item.lesson_id,
              };
              this.$store.commit('CHANGE_COURSE_INFORMATION', courseInfo);
              this.chapterList.push({
                course_id: item.course_id,
                lesson_id: item.lesson_id,
                lesson_name: item.lesson_name,
                module_id: item.module_id,
                module_name: item.module_name,
                packInfo: this.packInfoList,
                active: true,
              });
            } else {
              this.chapterList.push({
                course_id: item.course_id,
                lesson_id: item.lesson_id,
                lesson_name: item.lesson_name,
                module_id: item.module_id,
                module_name: item.module_name,
                active: false,
              });
            }
          });
        }
      });
    },
    // 根据课次获取对应的知识点列表
    async getQuestionPackageList(item) {
      this.packInfoList = [];
      const params = {
        subject_id: this.categoryObj.subjectId,
        hw_type: 3,
        module_id: item.lesson_id,
      };
      await getQuestionPackageList(params).then((res) => {
        if (res.code === 200) {
          const knowledgeArr = res.data;
          if (knowledgeArr.length > 0) {
            knowledgeArr.forEach((knowledge) => {
              this.packInfoList.push({
                tag_code: knowledge.tag_code,
                tag_name: knowledge.tag_name,
                active: false,
              });
            });
          }
        }
      });
    },
    onToggle(item) {
      console.log('-------', item);
    },
    previewResource() {
      this.$router.push({
        path: '/pt/preview-resource',
      });
    },
  },
  activated() {
    // 缓存处理
    if (!this.$route.meta.isUseCache) {
      console.log('不使用缓存----------------');
      if (this.categoryObj.subjectId !== '' && this.categoryObj.gradeId !== '' && this.categoryObj.textbookId !== '') {
        this.queryCourseTree();
      }
    } else {
      console.log('使用缓存----------------');
      this.$route.meta.isUseCache = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.p-create-at {
  .at-header {
    height: 73px;
    background: url("../images/intelligent_study.png") no-repeat right center;
    background-size: 520px 73px;
  }
  .create-at-content {
    display: flex;
  }
  .f-left {
    width: 256px;
    box-shadow: 2px 0px 8px 0px rgba(220, 225, 236, 0.5);
    padding-top: 6px;
    min-height: 780px;
    position: relative;
  }
  .f-main {
    flex: 1;
    padding-left: 24px;
    header {
      display: flex;
      justify-content: space-between;
      padding-top: 31px;
      padding-bottom: 11px;
      border-bottom: 1px solid #ebeef5;
      .look {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1989fa;
        background: url("../images/file.png") no-repeat center left;
        background-size: 24px 22px;
        padding-left: 30px;
      }
    }
    .circle-check-item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-left: 8px;
      .circle-check-box {
        position: relative;
        width: 12px;
        height: 12px;
        margin-right: 12px;
        border: 1px solid rgba(17, 31, 44, 0.4);
        // border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        &:after {
          position: absolute;
          width: 3px;
          height: 6px;
          left: 2.5px;
          // top: 3px;
          box-sizing: content-box;
          content: "";
          border: 2px solid #ffffff;
          border-left: 0;
          border-top: 0;
          transform: rotate(45deg) scaleY(0);
          transition: transform 0.15s ease-in 0.05s;
          transform-origin: center;
        }
      }
      &.is-checked {
        .circle-check-box {
          background-color: #409eff;
          border-color: #409eff;
          &:after {
            transform: rotate(45deg) scaleY(1);
          }
        }
      }
    }
    .chapter-list {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 5px;
      flex-wrap: wrap;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: bolder;
      color: #000000;
      .chapter-plus {
        height: 12px;
        width: 12px;
        color: rgba(0, 0, 0, 1);
        font-size: 16px;
        // padding-left: 18px;
        margin-left: 32px;
        background-repeat: no-repeat;
        background-size: 12px 12px;
        background-image: url("~@/views/pt/images/plus.png");
        & + .chapter-plus {
          margin-top: 10px;
        }
        &.is-active {
          background-image: url("~@/views/pt/images/minus.png");
        }
      }
      .lesson-list {
        width: 100%;
        .c-course-subtitle {
          color: rgba(96, 98, 102, 1);
          font-size: 15px;
          margin: 13px 0;
          position: relative;
          background-position: 70px center;
          background-repeat: no-repeat;
          background-size: 12px 12px;
          background-image: url("~@/views/pt/images/minus_2.png");
          padding-left: 16px;
          &.is-active {
            color: rgba(25, 137, 250, 1);
          }
          &::before {
            content: "";
            height: 100%;
            width: 1px;
            border-left: 1px dashed rgba(196, 200, 210, 1);
            left: 76px;
            top: 18px;
            position: absolute;
          }
          &:last-of-type::before {
            display: none;
          }
        }
        .lesson-item {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding-left: 90px;
          margin-top: 16px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #606266;
          .circle-check-item {
            margin-left: 0px;
          }
        }
      }
    }
  }
  .selector-container {
    margin-bottom: 30px;
    .version-header {
      width: 240px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #c4c8d2;
      line-height: 40px;
      font-size: 14px;
      padding: 0 15px;
      box-sizing: border-box;
      overflow: hidden;
    }
    .is-blue {
      border: 1px solid #1989fa;
    }
  }
  .c-subtile {
    color: rgba(48, 49, 51, 0.6);
    font-size: 14px;
    margin-top: 20px;
    padding-bottom: 20px;
  }
}
</style>
